import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import VisitorCounter from '../components/VisitorCounter';


function Home() {
  const [tabName, setTabName] = useState('BLRC');
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);
  
  const toast = useToast()
  const toastIdRef = React.useRef()

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const descRef = useRef(null);

  const handleWhatsAppClick = () => {
    const phoneNumber = "918432252624"; // WhatsApp number with country code (91 for India)
    const message = encodeURIComponent("Hello, I would like to know more about your services.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  // Star Rating Component
  const StarRating = ({ rating }) => {
    return (
      <div style={{ display: 'flex', gap: '4px', marginTop: '10px', marginBottom: '10px' }}>
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            style={{
              color: index < rating ? '#FFD700' : '#E0E0E0',
              fontSize: '18px',
              lineHeight: '1'
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  // Client Logo Component with fallback to initials
  const ClientLogo = ({ logo, name, company }) => {
    const [imageError, setImageError] = useState(false);
    
    return (
      <div
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: imageError 
            ? 'linear-gradient(135deg, #a68947 0%, #634f23 100%)' 
            : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: '24px',
          fontWeight: 'bold',
          flexShrink: 0,
          overflow: 'hidden',
          border: '2px solid #fff',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        {!imageError && logo ? (
          <img
            src={logo}
            alt={company}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            onError={() => setImageError(true)}
          />
        ) : (
          <span>{name.charAt(0)}</span>
        )}
      </div>
    );
  };

  // Testimonials Data
  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      company: "TechStart Solutions",
      logo: "assets/images/testimonials/client1.png", // Placeholder - replace with actual logo
      review: "BLRC provided exceptional service for our company registration. Their expertise in business law made the entire process smooth and hassle-free. Highly recommended!",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      company: "Sharma Enterprises",
      logo: "assets/images/testimonials/client2.png", // Placeholder - replace with actual logo
      review: "The team at BLRC helped us navigate complex GST compliance issues. Their clear communication and professional approach saved us time and money. Excellent service!",
      rating: 5
    },
    {
      id: 3,
      name: "Amit Patel",
      company: "Patel Industries",
      logo: "assets/images/testimonials/client3.png", // Placeholder - replace with actual logo
      review: "We needed help with contract drafting and IPR protection. BLRC delivered exactly what we needed with attention to detail and practical solutions. Great experience!",
      rating: 5
    }
  ];

  const handleSave = async () => {

     // Email validation regex
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // Mobile number validation regex (10-digit numeric)
  const mobileRegex = /^[0-9]{10}$/;

    if (!name) {
      toastIdRef.current = toast({
        description: "Please Enter Name",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      return;
    }
    if (!email) {
      toastIdRef.current = toast({
        description: "Please Enter Email Id",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      return;
    } else if (!emailRegex.test(email)) {
      toastIdRef.current = toast({
        description: "Please enter a valid Email Id",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      return;
    }
    
    if (!mobile) {
      toastIdRef.current = toast({
        description: "Please Enter Mobile Number",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      return;
    } else if (!mobileRegex.test(mobile)) {
      toastIdRef.current = toast({
        description: "Please enter a valid 10-digit Mobile Number",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      return;
    }
  
    try {
      const response = await fetch(
        "https://myblrc.in/api/api.php?xAction=addContactUs",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: name,
            email: email,
            phone_number: mobile,
            query_description: descRef.current.value,
          }),
        }
      );
  
      const result = await response.json();
  
      if (result.data?.status === "success") {
        toastIdRef.current = toast({
          description: result.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
  
        // Clear fields on successful submission
        setName("");
        setEmail("");
        setMobile("");
        descRef.current.value = "";
      } else {
        toastIdRef.current = toast({
          description: "Something went wrong. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toastIdRef.current = toast({
        description: "Failed to submit the query. Please check your internet connection.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };
  

return (
    <>
 
  {/*====== NAVBAR NINE PART START ======*/}
  <section className="navbar-area navbar-nine">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <Link to="/" className="navbar-brand">
              <img src="assets/images/white-logo.svg" alt="Logo" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNine"
              aria-controls="navbarNine"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="toggler-icon" />
              <span className="toggler-icon" />
              <span className="toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse sub-menu-bar"
              id="navbarNine"
            >
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <a className="page-scroll active" href="#hero-area">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll active" href="#AboutUs">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="#services">
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="#WhyChoose">
                    Why Choose Us?
                  </a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="#contact">
                    Contact
                  </a>
                </li>
                <li className="nav-item">
                  <Link to="/blog" className="page-scroll">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div class="navbar-btn d-none d-lg-inline-block">
          <a class="menu-bar" href="#side-menu-left"><i class="lni lni-menu"></i></a>
          </div> */}
          </nav>
          {/* navbar */}
        </div>
      </div>
      {/* row */}
    </div>
    {/* container */}
  </section>
  {/*====== NAVBAR NINE PART ENDS ======*/}
  {/* Start header Area */}
  <section id="hero-area" className="header-area header-eight">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-12 col-12">
          <div className="header-content">
            <h1>BLRC Your Trusted Partner in Business Laws</h1>
            <p>
              BLRC specialize in Company Law, Income Tax, GST (Goods &amp;
              Services Tax), Contract Drafting, and IPR (Intellectual Property
              Rights), RERA (Real Estate Regulation Act). Whether you're a
              startup or an established business, we're here to simplify the
              legal process and help you focus on growing your business.
            </p>
            <h6
              style={{
                marginTop: 15,
                color: "#FFF",
                opacity: "0.7",
                fontWeight: 400
              }}
            >
              Contact us today for reliable and professional legal solutions!
            </h6>
            <p className="banner_numbers">
              <a href="tel:+91 7721889277">+91 7721889277</a>/
              <a href="tel:+91 8432252624">+91 8432252624</a>
            </p>
            {/* <div class="button">
          <a href="javascript:void(0)" class="btn primary-btn">Get Started</a>
          </div> */}
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-12">
          <div className="header-image">
            <img src="assets/images/header/banner.png" alt="#" />
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* End header Area */}
  {/*====== ABOUT FIVE PART START ======*/}
  <section id="AboutUs" className="about-area about-five">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 col-12">
          <div className="about-image-five">
            <svg
              className="shape"
              width={106}
              height={134}
              viewBox="0 0 106 134"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="1.66654" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="1.66654" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="16.3333" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="16.3333" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="16.3333" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="16.3333" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="16.333" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="30.9998" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="74.6665" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="30.9998" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="74.6665" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="30.9998" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="74.6665" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="30.9998" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="74.6665" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx={31} cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx={31} cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx={31} cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx={31} cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx={31} cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx={31} cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="74.6668" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="45.6665" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="89.3333" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx="60.3333" cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="1.66679" r="1.66667" fill="#DADADA" />
              <circle cx="60.3333" cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="16.3335" r="1.66667" fill="#DADADA" />
              <circle cx="60.3333" cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="31.0001" r="1.66667" fill="#DADADA" />
              <circle cx="60.3333" cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="45.6668" r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="60.3335" r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="88.6668" r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="117.667" r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx={104} cy="74.6668" r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy={103} r="1.66667" fill="#DADADA" />
              <circle cx={104} cy={103} r="1.66667" fill="#DADADA" />
              <circle cx="60.333" cy={132} r="1.66667" fill="#DADADA" />
              <circle cx={104} cy={132} r="1.66667" fill="#DADADA" />
            </svg>
            <img src="assets/images/about/about.jpeg" alt="about" />
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="about-five-content">
            <h2 className="main-title fw-bold">About Us</h2>
            <p className="main-title fw-bold">
              Business Law Relief Center- BLRC Based in Nashik (India), we are a
              legal firm focused on providing practical business law solutions.
              We assist individuals, startups, and companies in navigating legal
              challenges with ease. Our approach is client-focused, offering
              services that are clear, affordable, and tailored to each client's
              needs. With us, understanding the law becomes simple and
              stress-free.
            </p>
            <div className="about-five-tab">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-who-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-who"
                    type="button"
                    role="tab"
                    aria-controls="nav-who"
                    aria-selected="true"
                  >
                    Founder's Message
                  </button>
                  <button
                    className="nav-link"
                    id="nav-vision-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-vision"
                    type="button"
                    role="tab"
                    aria-controls="nav-vision"
                    aria-selected="false"
                  >
                    Vision
                  </button>
                  <button
                    className="nav-link"
                    id="nav-history-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-history"
                    type="button"
                    role="tab"
                    aria-controls="nav-history"
                    aria-selected="false"
                  >
                    Mission
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-who"
                  role="tabpanel"
                  aria-labelledby="nav-who-tab"
                >
                  <p>
                    As a lawyer with years of experience in business laws, my
                    aim is to bridge the gap between complex legal systems and
                    everyday business needs. My mission is to simplify the law
                    for clients, provide actionable advice, and empower them to
                    make informed decisions that support their success and
                    growth.
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-vision"
                  role="tabpanel"
                  aria-labelledby="nav-vision-tab"
                >
                  <p>
                    To be a trusted legal partner for businesses, fostering
                    their growth and success by offering simplified and
                    accessible legal services. We envision a future where every
                    business can operate with confidence, knowing they have
                    expert legal guidance by their side.
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-history"
                  role="tabpanel"
                  aria-labelledby="nav-history-tab"
                >
                  <p>
                    Our mission is to make legal solutions easy to understand
                    and implement. We aim to provide affordable, efficient, and
                    reliable services that help clients comply with the law,
                    avoid disputes, and grow their businesses confidently and
                    sustainably.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* container */}
  </section>
  {/*====== ABOUT FIVE PART ENDS ======*/}
  {/* ===== service-area start ===== */}
  <section id="services" className="services-area services-eight">
    {/*======  Start Section Title Five ======*/}
    <div className="section-title-five">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="content">
              {/* <h6>Services</h6> */}
              <h2 className="fw-bold">Services</h2>
              {/* <p>
              There are many variations of passages of Lorem Ipsum available,
              but the majority have suffered alteration in some form.
          </p> */}
            </div>
          </div>
        </div>
        {/* row */}
      </div>
      {/* container */}
    </div>
    {/*======  End Section Title Five ======*/}
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-company-law" />
            </div>
            <div className="service-content">
              <h4>Company Law</h4>
              <p>
                BLRC help with company registration, incorporation, and
                compliance. From drafting Memorandum and Articles of Association
                to ensuring your business adheres to all legal requirements, we
                provide end-to-end support to help your company operate
                seamlessly and legally.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-income-tax" />
            </div>
            <div className="service-content">
              <h4>Income Tax</h4>
              <p>
                Our tax services cover filing returns, tax planning, and
                representation in disputes. We simplify the process of managing
                income tax, ensuring timely compliance and helping you save
                money through effective tax strategies.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-gst" />
            </div>
            <div className="service-content">
              <h4>GST (Goods and Services Tax)</h4>
              <p>
                BLRC assist with GST registration, filing of returns, and
                resolving issues during audits and appeals. Our goal is to make
                GST compliance easy and stress-free so you can focus on running
                your business.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-contract-agree" />
            </div>
            <div className="service-content">
              <h4>Contracts and Agreements</h4>
              <p>
                BLRC draft, review, and negotiate contracts and agreements
                tailored to your business needs. Whether it's employment
                contracts, service agreements, or vendor partnerships, we ensure
                your interests are protected and legally sound.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-intellectual-property" />
            </div>
            <div className="service-content">
              <h4>IPR (Intellectual Property Rights)</h4>
              <p>
                Our IPR services include trademark registration, copyright and
                patent advisory, and enforcement of intellectual property
                rights. We protect your brand and ideas, ensuring they remain
                exclusive and legally protected.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-services">
            <div className="service-icon">
              <i className="lni icon-approved" />
            </div>
            <div className="service-content">
              <h4>RERA (Real Estate Regulation Act)</h4>
              <p>
                BLRC assists with compliance, registration, dispute resolution,
                and advisory services under the Real Estate Regulation Act.
                Whether you are a developer or a buyer, we ensure your real
                estate transactions are transparent, secure, and legally
                compliant.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* ===== service-area end ===== */}
  {/* Start Cta Area */}
  <section id="WhyChoose" className="call-action">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xxl-6 col-xl-7 col-lg-8 col-md-9">
          <div className="inner-content">
            <h2>Why Choose Us?</h2>
            <p>
              BLRC understand that legal matters can feel overwhelming. That's
              why BLRC provide solutions in simple, clear language. With years
              of experience, BLRC offer expert advice tailored to your unique
              needs. Our services are affordable, timely, and focused on helping
              your business stay compliant and successful.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* End Cta Area */}
  {/* ========================= Testimonials Section Start ========================= */}
  <section id="testimonials" className="testimonials-area" style={{ paddingTop: '100px', paddingBottom: '100px', background: '#f5f5f5' }}>
    <div className="section-title-five">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="content">
              <h2 className="fw-bold">What Our Clients Say</h2>
              <p>
                Don't just take our word for it - hear from our satisfied clients
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="col-lg-4 col-md-6" style={{ marginBottom: '30px' }}>
            <div
              className="single-testimonial"
              style={{
                background: '#fff',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                <ClientLogo 
                  logo={testimonial.logo} 
                  name={testimonial.name} 
                  company={testimonial.company} 
                />
                <div style={{ flex: 1 }}>
                  <h5 style={{ margin: 0, color: '#1d1d1d', fontWeight: 600 }}>
                    {testimonial.name}
                  </h5>
                  <p style={{ margin: '5px 0 0 0', color: '#6d6d6d', fontSize: '14px' }}>
                    {testimonial.company}
                  </p>
                </div>
              </div>
              <StarRating rating={testimonial.rating} />
              <div style={{ position: 'relative', flex: 1 }}>
                <span
                  style={{
                    position: 'absolute',
                    top: '-10px',
                    left: '-5px',
                    fontSize: '60px',
                    color: '#a68947',
                    opacity: 0.1,
                    fontFamily: 'Georgia, serif',
                    lineHeight: '1'
                  }}
                >
                  "
                </span>
                <p
                  style={{
                    color: '#4d4d4d',
                    lineHeight: '1.6',
                    fontSize: '15px',
                    marginTop: '10px',
                    paddingLeft: '15px',
                    fontStyle: 'italic'
                  }}
                >
                  {testimonial.review}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    <style>
      {`
        @media (max-width: 991px) {
          .testimonials-area {
            padding-top: 80px !important;
            padding-bottom: 80px !important;
          }
        }
        @media (max-width: 767px) {
          .testimonials-area {
            padding-top: 60px !important;
            padding-bottom: 60px !important;
          }
          .single-testimonial {
            padding: 20px !important;
          }
        }
      `}
    </style>
  </section>
  {/* ========================= Testimonials Section End ========================= */}
  {/* ========================= contact-section start ========================= */}
  <section id="contact" className="contact-section">
    <div className="container">
      <div className="row">
        <div className="col-xl-4">
          <div className="contact-item-wrapper">
            <div className="row">
              <div className="col-12 col-md-6 col-xl-12">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="lni lni-phone" />
                  </div>
                  <div className="contact-content">
                    <h4>Contact</h4>
                    <p>
                      <a href="tel:+91 7721889277">+91 7721889277</a>
                    </p>
                    <p>
                      <a href="tel:+91 8432252624">+91 8432252624</a>
                    </p>
                    <p>
                      <a href="mailto:enquiry@myblrc.com">enquiry@myblrc.com</a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-12">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="lni lni-map-marker" />
                  </div>
                  <div className="contact-content">
                    <h4>Address</h4>
                    <p>
                      Flat No. 18, Ever smile Apartment, Behind Hotel Banjara,
                      Mahatma Nagar, Nashik, India
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          <div className="contact-form-wrapper">
            <div className="row">
              <div className="col-xl-10 col-lg-8 mx-auto">
                <div className="section-title text-center">
                  {/* <span> Get in Touch </span> */}
                  <h2>Contact Us</h2>
                  {/*  <p>
                  Contact us today for reliable and professional legal solutions!
              </p> */}
                </div>
              </div>
            </div>
            <form action="#" className="contact-form">
              <div className="row">
                <div className="col-md-6">
                  <input type="text" name="name" id="name" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                
                <div className="col-md-6">
                  <input type="email" name="email" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <input type="text" name="phone" id="phone" placeholder="Phone" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                </div>
                {/* <div class="col-md-6">
              <input type="text" name="subject" id="email" placeholder="Subject" required />
              </div> */}
              </div>
              <div className="row">
                <div className="col-12">
                  <textarea name="message" id="message" placeholder="Type Query" rows={5}  ref={descRef} />
                </div>
              </div>
             
              <div className="row">
                <div className="col-12">
                  <div className="button text-center rounded-buttons">
                  <ChakraProvider>
                  <Wrap>

                    <button  type="button" className="btn primary-btn rounded-full"   onClick={handleSave}>
                      Send Message
                    </button>
                    </Wrap>
                    </ChakraProvider>
                  </div>
                </div>
              
              </div>
             
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* ========================= contact-section end ========================= */}
  {/* ========================= map-section end ========================= */}
  <section className="map-section" style={{marginTop:30}}>
    <div className="map-container">
      <object
        style={{ border: 0, height: 500, width: "100%" }}
        data="https://maps.google.com/maps?hl=en&q=Flat No. 18, Ever smile Apartment, Behind Hotel Banjara, Mahatama Nagar, Nashik, India&t=&z=14&ie=UTF8&iwloc=B&output=embed"
      />
    </div>
  </section>
  {/* ========================= map-section end ========================= */}
  {/* Start Footer Area */}
  <footer className="footer-area footer-eleven">
    {/* Start Footer Top */}
    <div className="footer-top">
      <div className="container">
        <div className="inner-content">
          <p className="copyright-text">© 2025 BLRC All rights reserved.</p>
        </div>
      </div>
    </div>
    {/*/ End Footer Top */}
  </footer>
  {/*/ End Footer Area */}
  <a href="#" className="scroll-top btn-hover">
    <i className="lni lni-chevron-up" />
  </a>
  
  {/* WhatsApp Floating Button */}
  <div
    className="whatsapp-float"
    onClick={handleWhatsAppClick}
    style={{
      position: "fixed",
      width: "45px",
      height: "45px",
      bottom: "100px",
      right: "30px",
      backgroundColor: "#25D366",
      color: "#FFF",
      borderRadius: "50px",
      textAlign: "center",
      fontSize: "24px",
      boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
      zIndex: 999,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
      animation: "pulse 2s infinite"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "2px 2px 15px rgba(0,0,0,0.4)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "2px 2px 10px rgba(0,0,0,0.3)";
    }}
    title="Chat with us on WhatsApp"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
        fill="currentColor"
      />
    </svg>
    <style>
      {`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }
        @media (max-width: 768px) {
          .whatsapp-float {
            width: 40px !important;
            height: 40px !important;
            bottom: 85px !important;
            right: 20px !important;
            font-size: 20px !important;
          }
        }
      `}
    </style>
  </div>

  <VisitorCounter />

   </>
  );
}

export default Home;
